import { render, staticRenderFns } from "./BlogPostsTemplate.vue?vue&type=template&id=09e0f10b&scoped=true&"
import script from "./BlogPostsTemplate.vue?vue&type=script&lang=ts&"
export * from "./BlogPostsTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPostsTemplate.vue?vue&type=style&index=0&id=09e0f10b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0f10b",
  null
  
)

export default component.exports